<p class="section-description">
  Click any button to open the corresponding modal with mock data — for visual testing only. Buttons that need a loaded
  application are disabled until one is available.
</p>
<h3 class="modal-group-title">Recovery flow</h3>
<div class="modal-buttons-grid">
  <button class="arpio-button" (click)="openLaunchRecovery()" [disabled]="!application">Launch recovery (AWS)</button>
  <button class="arpio-button" (click)="openLaunchRecoveryAzure()" [disabled]="!application">
    Launch recovery (Azure)
  </button>
  <button class="arpio-button" (click)="openLaunchTest()" [disabled]="!application">Launch test</button>
  <button class="arpio-button" (click)="openConcludeRecovery()" [disabled]="!application">Conclude recovery</button>
  <button class="arpio-button" (click)="openConcludeTest()" [disabled]="!application">Conclude test</button>
  <button class="arpio-button" (click)="openStopTest()" [disabled]="!application">Cancel test (early)</button>
  <button class="arpio-button" (click)="openFailback()" [disabled]="!application">Failback</button>
  <button class="arpio-button" (click)="openUnquarantine()" [disabled]="!application">Unquarantine (AWS)</button>
  <button class="arpio-button" (click)="openUnquarantineAzure()" [disabled]="!application">Unquarantine (Azure)</button>
  <button class="arpio-button" (click)="openAppTestConfig()" [disabled]="!application">Sandbox settings (basic)</button>
  <button class="arpio-button" (click)="openAppTestConfigAdvanced()" [disabled]="!application">
    Sandbox settings (advanced)
  </button>
  <button class="arpio-button" (click)="openSandboxEvents()" [disabled]="!application">
    Network sandbox events (empty)
  </button>
  <button class="arpio-button" (click)="openSandboxEventsPopulated()" [disabled]="!application">
    Network sandbox events (populated)
  </button>
  <button class="arpio-button" (click)="openAreYouSure()" [disabled]="!application">Recovery "Are you sure"</button>
</div>
<h3 class="modal-group-title">Network sandbox — customer configurations</h3>
<p class="section-description">
  Each scenario fixes the cloud, recovery-point contents, and account capabilities that drive the sandbox UI's
  conditional logic, then opens the dialog in that one rendered state.
</p>
<div class="sandbox-scenario-pickers">
  <div class="sandbox-scenario-picker">
    <label class="recovery-screen-picker">
      <span class="recovery-screen-picker-label">Launch test dialog</span>
      <select class="arpio-select" (change)="launchTestSandboxKey = $any($event.target).value">
        <optgroup *ngFor="let group of launchTestSandboxGroups" [label]="group.group">
          <option
            *ngFor="let scenario of group.scenarios"
            [value]="scenario.key"
            [selected]="scenario.key === launchTestSandboxKey"
          >
            {{ scenario.label }}
          </option>
        </optgroup>
      </select>
    </label>
    <button class="arpio-button" (click)="openLaunchTestSandboxScenario()" [disabled]="!application">Open</button>
  </div>
  <div class="sandbox-scenario-picker">
    <label class="recovery-screen-picker">
      <span class="recovery-screen-picker-label">Sandbox settings dialog</span>
      <select class="arpio-select" (change)="sandboxConfigKey = $any($event.target).value">
        <optgroup *ngFor="let group of sandboxConfigGroups" [label]="group.group">
          <option
            *ngFor="let scenario of group.scenarios"
            [value]="scenario.key"
            [selected]="scenario.key === sandboxConfigKey"
          >
            {{ scenario.label }}
          </option>
        </optgroup>
      </select>
    </label>
    <button class="arpio-button" (click)="openSandboxConfigScenario()" [disabled]="!application">Open</button>
  </div>
</div>
<h3 class="modal-group-title">Generic / shared</h3>
<div class="modal-buttons-grid">
  <button class="arpio-button" (click)="openConfirmAction()">Confirm action</button>
  <button class="arpio-button" (click)="openUpdateAccess()">Update access</button>
  <button class="arpio-button" (click)="openEditIntegration()">Edit integration</button>
</div>
<h3 class="modal-group-title">Support / retention / issues</h3>
<div class="modal-buttons-grid">
  <button class="arpio-button" (click)="openSubmitTicket()">Submit ticket</button>
  <button class="arpio-button" (click)="openConfirmTicket()">Ticket opened (confirmation)</button>
  <button class="arpio-button" (click)="openReleaseRps()">Release recovery points</button>
  <button class="arpio-button" (click)="openConfirmManualReplication()">Confirm manual replication</button>
  <button class="arpio-button" (click)="openConfirmEbsSnapshot()">Confirm EBS snapshot replication</button>
</div>
<h3 class="modal-group-title">Users / roles / groups</h3>
<div class="modal-buttons-grid">
  <button class="arpio-button" (click)="openInviteUsers()">Invite users</button>
  <button class="arpio-button" (click)="openEditUser()">Edit user</button>
  <button class="arpio-button" (click)="openNewRole()">New role</button>
  <button class="arpio-button" (click)="openEditRole()">Edit role</button>
  <button class="arpio-button" (click)="openNewGroup()">New group</button>
  <button class="arpio-button" (click)="openEditGroup()">Edit group</button>
  <button class="arpio-button" (click)="openIdpModal()">IdP</button>
</div>
<h3 class="modal-group-title">API keys</h3>
<div class="modal-buttons-grid">
  <button class="arpio-button" (click)="openNewApiKey()">New API key</button>
  <button class="arpio-button" (click)="openEditApiKey()">Edit API key</button>
</div>
<!-- Template-based modals: each is hosted by a modal-dialog with an
ng-template body that mounts the actual dialog component. -->
@if (application) {
  <modal-dialog #launchRecoveryDialog [dialogTemplate]="launchRecoveryTpl"></modal-dialog>
  <ng-template #launchRecoveryTpl>
    <launch-recovery-dialog
      [application]="application"
      (cancel)="launchRecoveryDialog.close()"
      (launch)="launchRecoveryDialog.close()"
    ></launch-recovery-dialog>
  </ng-template>
  <modal-dialog #launchTestDialog [dialogTemplate]="launchTestTpl"></modal-dialog>
  <ng-template #launchTestTpl>
    <launch-test-dialog
      [application]="application"
      [currentlySyncing]="false"
      [launching]="mockLaunchTestLaunching"
      (cancel)="resetMockCapabilities(); launchTestDialog.close()"
      (launch)="mockLaunchTestLaunching = true"
    ></launch-test-dialog>
  </ng-template>
  <modal-dialog #concludeRecoveryDialog [dialogTemplate]="concludeRecoveryTpl"></modal-dialog>
  <ng-template #concludeRecoveryTpl>
    <conclude-recovery-dialog
      [application]="application"
      [currentlySyncing]="false"
      (cancel)="concludeRecoveryDialog.close()"
      (conclude)="concludeRecoveryDialog.close()"
    ></conclude-recovery-dialog>
  </ng-template>
  <modal-dialog #concludeTestDialog [dialogTemplate]="concludeTestTpl"></modal-dialog>
  <ng-template #concludeTestTpl>
    <conclude-test-dialog
      [application]="application"
      (cancel)="concludeTestDialog.close()"
      (conclude)="concludeTestDialog.close()"
    ></conclude-test-dialog>
  </ng-template>
  <modal-dialog #stopTestDialog [dialogTemplate]="stopTestTpl"></modal-dialog>
  <ng-template #stopTestTpl>
    <conclude-test-dialog
      [application]="application"
      [isEarlyStop]="true"
      (cancel)="stopTestDialog.close()"
      (conclude)="stopTestDialog.close()"
    ></conclude-test-dialog>
  </ng-template>
  <modal-dialog #failbackDialog [dialogTemplate]="failbackTpl"></modal-dialog>
  <ng-template #failbackTpl>
    <failback-dialog
      [application]="application"
      (cancel)="failbackDialog.close()"
      (failback)="failbackDialog.close()"
    ></failback-dialog>
  </ng-template>
  <modal-dialog #unquarantineDialog [dialogTemplate]="unquarantineTpl"></modal-dialog>
  <ng-template #unquarantineTpl>
    <unquarantine-dialog [application]="application" (close)="unquarantineDialog.close()"></unquarantine-dialog>
  </ng-template>
  <modal-dialog #appTestConfigDialog [dialogTemplate]="appTestConfigTpl"></modal-dialog>
  <ng-template #appTestConfigTpl>
    <application-test-config-dialog
      [application]="application"
      [currentlySyncing]="false"
      (cancel)="resetMockCapabilities(); appTestConfigDialog.close()"
      (launch)="resetMockCapabilities(); appTestConfigDialog.close()"
    ></application-test-config-dialog>
  </ng-template>
  <modal-dialog #appTestConfigAdvancedDialog [dialogTemplate]="appTestConfigAdvancedTpl"></modal-dialog>
  <ng-template #appTestConfigAdvancedTpl>
    <application-test-config-dialog
      [application]="application"
      [currentlySyncing]="false"
      (cancel)="appTestConfigAdvancedDialog.close()"
      (launch)="appTestConfigAdvancedDialog.close()"
    ></application-test-config-dialog>
  </ng-template>
  <modal-dialog #awsEventLogsDialog [dialogTemplate]="awsEventLogsTpl"></modal-dialog>
  <ng-template #awsEventLogsTpl>
    <app-aws-event-logs
      [accountId]="application.accountId"
      [applicationId]="application.applicationId"
      (close)="awsEventLogsDialog.close()"
    ></app-aws-event-logs>
  </ng-template>
  <!-- Inline "Are you sure?" recovery confirm — copied verbatim from
  application.component.html so the test page can verify its
  close button + escape handler in isolation. -->
  <modal-dialog #areYouSureDialog [dialogTemplate]="areYouSureTpl"></modal-dialog>
  <ng-template #areYouSureTpl>
    <div class="flex-left-column light-control-host">
      <div class="modal-header">
        <h3 class="panel-title">Launch recovery for these applications?</h3>
        <button
          type="button"
          class="modal-close-btn"
          (click)="areYouSureDialog.close()"
          pTooltip="Close"
          tooltipPosition="left"
          aria-label="Close"
        >
          <i class="fa-utility fa-semibold fa-xmark"></i>
        </button>
      </div>
      <div class="modal-subtitle"><strong>Quarantine Mode:</strong> ON</div>
      <ul>
        <li>{{ application.name }}</li>
      </ul>
      <div class="notice-warning">
        <i class="fa-solid fa-circle-exclamation"></i>
        <p>
          Launching a Recovery will restore your application in your recovery environment without the safeguards of a
          Test.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="arpio-secondary-button" (click)="areYouSureDialog.close()">
          No, Cancel Recovery
        </button>
        <button type="button" class="arpio-danger-button text-white" (click)="areYouSureDialog.close()">
          Yes, I'm sure
        </button>
      </div>
    </div>
  </ng-template>
}
<!-- Generic + integration modals (don't require an application) -->
<modal-dialog #confirmActionDialog [dialogTemplate]="confirmActionTpl"></modal-dialog>
<ng-template #confirmActionTpl>
  <confirm-action-dialog
    name="Mock resource"
    action="Delete"
    (onAction)="confirmActionDialog.close()"
    (onCancel)="confirmActionDialog.close()"
  ></confirm-action-dialog>
</ng-template>
<modal-dialog #updateAccessDialog [dialogTemplate]="updateAccessTpl"></modal-dialog>
<ng-template #updateAccessTpl>
  <update-access-dialog
    [applicationType]="applicationTypeAws"
    [accessCheckResults]="mockAccessCheckResults"
    [sourceEndpointUri]="mockSourceEndpointUri"
    [targetEndpointUri]="mockTargetEndpointUri"
    (cancel)="updateAccessDialog.close()"
    (done)="updateAccessDialog.close()"
  ></update-access-dialog>
</ng-template>
<modal-dialog #editIntegrationDialog [dialogTemplate]="editIntegrationTpl"></modal-dialog>
<ng-template #editIntegrationTpl>
  <edit-integration-dialog
    [integration]="mockIntegration"
    (cancel)="editIntegrationDialog.close()"
    (save)="editIntegrationDialog.close()"
  ></edit-integration-dialog>
</ng-template>
<!-- Inline copies of dialogs that live inside other components
(support, account-retention-policy, issue-view children) so the
test page can preview them without instantiating those parents. -->
<modal-dialog #submitTicketDialog [dialogTemplate]="submitTicketTpl"></modal-dialog>
<ng-template #submitTicketTpl>
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Open a ticket</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="submitTicketDialog.close()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <i class="fa-utility fa-semibold fa-xmark"></i>
      </button>
    </div>
    <div class="modal-subtitle">Tell us what's going on and we'll get back to you within 4 business hours.</div>
    <form class="support-form" [formGroup]="mockTicketFormModel">
      <fieldset style="grid-column: 1; grid-row: 1">
        <label for="testYourEmail">Your email</label>
        <input id="testYourEmail" class="arpio-input" type="email" formControlName="email" />
      </fieldset>
      <fieldset style="grid-column: 2; grid-row: 1">
        <label for="testTicketPriority">Priority</label>
        <div class="select-wrapper">
          <select id="testTicketPriority" class="arpio-select full-width" formControlName="ticketPriority">
            <option value="LOW">Low</option>
            <option value="MEDIUM">Medium</option>
            <option value="HIGH">High</option>
          </select>
        </div>
      </fieldset>
      <fieldset style="grid-column: 1 / 3; grid-row: 2">
        <label for="testTicketSubject">Subject</label>
        <input id="testTicketSubject" class="arpio-input" type="text" formControlName="ticketSubject" />
      </fieldset>
      <fieldset style="grid-column: 1 / 3; grid-row: 3 / 5">
        <label for="testTicketContent">Description</label>
        <textarea id="testTicketContent" class="arpio-input" formControlName="ticketContent"></textarea>
      </fieldset>
    </form>
    <div class="modal-footer">
      <button type="button" class="arpio-secondary-button" (click)="submitTicketDialog.close()">Cancel</button>
      <button type="button" class="arpio-button" (click)="submitTicketDialog.close()">Submit</button>
    </div>
  </div>
</ng-template>
<modal-dialog #confirmTicketDialog [dialogTemplate]="confirmTicketTpl"></modal-dialog>
<ng-template #confirmTicketTpl>
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Ticket opened</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="confirmTicketDialog.close()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <i class="fa-utility fa-semibold fa-xmark"></i>
      </button>
    </div>
    <div class="ticket-confirmation-body" [innerHTML]="mockHubspotResponse"></div>
    <div class="modal-footer">
      <button type="button" class="arpio-secondary-button" (click)="confirmTicketDialog.close()">Close</button>
    </div>
  </div>
</ng-template>
<modal-dialog #releaseRpsDialog [dialogTemplate]="releaseRpsTpl"></modal-dialog>
<ng-template #releaseRpsTpl>
  <div class="flex-center-column full-width">
    <confirm-action-dialog
      action="Release"
      name="Recovery Points"
      [error]="null"
      (onCancel)="releaseRpsDialog.close()"
      (onAction)="releaseRpsDialog.close()"
      [busy]="false"
    >
      <div class="error margin-top">
        Note: After the Recovery Points are released they are eligible for clean up and may be deleted by Arpio.
      </div>
    </confirm-action-dialog>
  </div>
</ng-template>
<modal-dialog #confirmManualReplicationDialog [dialogTemplate]="confirmManualReplicationTpl"></modal-dialog>
<ng-template #confirmManualReplicationTpl>
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Configuring Bucket Replication</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="confirmManualReplicationDialog.close()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <i class="fa-utility fa-semibold fa-xmark"></i>
      </button>
    </div>
    <div class="modal-subtitle">You're choosing to configure replication yourself. Here's what happens next:</div>
    <ol>
      <li>Arpio will create a new bucket in the recovery environment if it doesn't already exist.</li>
      <li>
        Arpio will create an IAM role in the production environment with minimal permissions to replicate objects to the
        recovery environment bucket.
      </li>
      <li>
        Arpio will create a new issue in this console with the details necessary for you to configure replication
        yourself.
      </li>
    </ol>
    <p>When you see the new issue here in Arpio it will be time to configure replication. Hang tight until then.</p>
    <div class="modal-footer">
      <button type="button" class="arpio-secondary-button" (click)="confirmManualReplicationDialog.close()">
        CANCEL
      </button>
      <button type="button" class="arpio-button" (click)="confirmManualReplicationDialog.close()">CONTINUE</button>
    </div>
  </div>
</ng-template>
<modal-dialog #confirmEbsSnapshotDialog [dialogTemplate]="confirmEbsSnapshotTpl"></modal-dialog>
<ng-template #confirmEbsSnapshotTpl>
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Replication with EBS Snapshots</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="confirmEbsSnapshotDialog.close()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <i class="fa-utility fa-semibold fa-xmark"></i>
      </button>
    </div>
    <div class="modal-subtitle">
      You're choosing to replicate this server via EBS Snapshots. Here's what that means:
    </div>
    <ol>
      <li>The Elastic Disaster Recovery service will not be used to replicate this server's data as it is updated.</li>
      <li>
        Instead, Arpio will take frequent snapshots of the server's disks and copy them to the recovery environment.
      </li>
      <li>
        During a recovery, this server will be re-created from these snapshots, and the very latest data from the server
        may not be included.
      </li>
      <li>But you will not need to install an agent on the server, and your AWS bill will be lower.</li>
    </ol>
    <p>Choose Use Snapshots to proceed, or Cancel to go back.</p>
    <div class="modal-footer">
      <button type="button" class="arpio-secondary-button" (click)="confirmEbsSnapshotDialog.close()">CANCEL</button>
      <button type="button" class="arpio-button" (click)="confirmEbsSnapshotDialog.close()">USE SNAPSHOTS</button>
    </div>
  </div>
</ng-template>
<!-- Self-wrapped modals: these components own their own modal-dialog,
so we just instantiate them and call .open() on the component. -->
<app-new-role-modal #newRoleModal></app-new-role-modal>
<app-edit-role-modal #editRoleModal></app-edit-role-modal>
<app-new-group-modal #newGroupModal></app-new-group-modal>
<app-edit-group-modal #editGroupModal></app-edit-group-modal>
<app-edit-user-modal #editUserModal></app-edit-user-modal>
<app-invite-users-modal #inviteUsersModal></app-invite-users-modal>
<app-new-api-key-modal #newApiKeyModal></app-new-api-key-modal>
<app-edit-api-key-modal #editApiKeyModal></app-edit-api-key-modal>
<app-idp-modal #idpModal></app-idp-modal>
